import { API_PROTECTED_PATH, API_URL_PRD } from "../config/config";
import ApiClient from "../requests";
import store from "../../store";

// SYMPTOMS
export async function getSymptomes(payload: { lg: string; search: string }): Promise<TSymptome[]> {
  const _authToken = store.authToken;
  if (!_authToken) return [];

  const { lg = "", search = "" } = payload;
  const urlParams = `lang=${lg}&date_version=&searchString=${search}`;
  const Url = `${API_URL_PRD}${API_PROTECTED_PATH}symptom/getSymptoms?${urlParams}`;

  return await ApiClient.get(Url, _authToken);
}

export async function getSymptomesdetails(payload: { id: number }): Promise<TSymptomDetail | null> {
  const _authToken = store.authToken;
  if (!_authToken) return null;

  const urlParams = `symptom_id=${payload.id}`;
  const Url = `${API_URL_PRD}${API_PROTECTED_PATH}symptom/getSymptom?${urlParams}`;

  const res = await ApiClient.get(Url, _authToken);
  //res.sections.splice(0, 0, { id: 0, photos: [] });
  return res;

}

export function getSymptomeImageById(symptomeId: number, symptomeList: TSymptome[]) {
  let retImg: string | undefined = undefined;

  for (let itm of symptomeList) {
    if (+itm.id === symptomeId) {
      retImg = itm.photo;
      return;
    }
  }

  return retImg;
}
